export default __webpack_public_path__ + "static/media/project1.1d459e8b.JPG";